import http from '@services/http'
import {
  INotification,
  IUserInfo,
  IUsers,
  IUserInfoDetails,
  IUserItems,
  IUserUseItem,
  IUserClubMessages,
  IBettingCoupons,
  IUserNick,
  Schema$doCheckDuplicateLogin,
  IUserMission,
  IUserMissionReward,
  IUserGameOptions,
  ISetUserGameOptions,
  IChangeUserProfileImage,
  IUserChatBlockFavoriteOptions,
  IUserAccounts,
  IDroppedUser,
  IPaymentRewardEvent,
  IReceivedPaymentRewardEvent,
  IClubNoticeReadHistory,
  IUserTitleEnabled, ICheckTransferableAccount, ITransferableAccountInfo, IRegisterAccountTransfer,
  IUsageGuideVideoAutoTarget,
} from '@protocol/user'
import { Schema$UserGuideBonusResult, Schema$UserMission } from '@interface/common'
import { schema_user_chat_option } from 'adv-lib/src/models/chat/user-chat-option'
import { IUserTitleDefs } from '@protocol/component'
import { IFavoriteAlarmSetting, IFavoriteUsers } from '@protocol/bettor'

export default {
  getUserInfo(data: IUserInfo.Params): Promise<IUserInfo.Schema> {
    return http.get('user/info', data || {})
  },

  /**
   * 여러 데이터중 userInfo 만 가지고온다
   */
  getSimpleUserInfo(): Promise<IUserInfo.Schema> {
    return http.get('user/simpleInfo', {})
  },

  getChatOption(): Promise<IUserInfo.Schema> {
    return http.get('user/chatOption', {})
  },

  //
  getUsers(data: IUsers.Params): Promise<IUsers.Schema> {
    return http.get('user/users', data || {})
  },

  createUser(data: IUserInfo.Params): Promise<IUserInfo.Schema> {
    return http.post('user/create', data || {})
  },

  modifyUser(data: IUserInfo.Params): Promise<IUserInfo.Schema> {
    return http.post('user/modify', data || {})
  },

  deleteUser(data: IUserInfo.Params): Promise<IUserInfo.Schema> {
    return http.post('user/delete', data || {})
  },

  getUserInfoDetails(data: IUserInfoDetails.Params): Promise<IUserInfoDetails.Schema> {
    return http.get('user/detail', data || {})
  },

  getUserItems(data: IUserItems.Params): Promise<IUserItems.Schema> {
    return http.post('user/items', data || {})
  },

  getUserGameOptions(data: IUserGameOptions.Params): Promise<IUserGameOptions.Schema> {
    return http.post('user/gameOptions', data || {})
  },

  setUserGameOptions(data: ISetUserGameOptions.Params): Promise<ISetUserGameOptions.Schema> {
    return http.post('user/setGameOptions', data || {})
  },

  getBettingCoupons(data: IBettingCoupons.Params): Promise<IBettingCoupons.Schema> {
    return http.post('user/bettingCoupons', data || {})
  },

  useUserItem(data: IUserUseItem.Params): Promise<IUserUseItem.Schema> {
    return http.post('user/useItem', data || {})
  },

  checkNick(data: IUserNick.Params): Promise<IUserNick.Schema> {
    return http.post('user/checkNick', data || {})
  },

  changeNick(data: IUserNick.Params): Promise<IUserNick.Schema> {
    return http.post('user/changeNick', data || {})
  },

  // ------- 유저의 메시지를 관리하는 부분 (클럽메시지) -------
  getMyClubSendMessageList(data: IUserClubMessages.SelectParams): Promise<IUserClubMessages.Schema> {
    return http.get('user/my-club-send-message-list', data || {})
  },

  getMyClubReceiveMessageList(data: IUserClubMessages.SelectParams): Promise<IUserClubMessages.Schema> {
    return http.get('user/my-club-receive-message-list', data || {})
  },

  doSendClubMessage(data: IUserClubMessages.InsertParams): Promise<IUserClubMessages.Schema> {
    return http.post('user/send-club-message', data || {})
  },

  doDeleteClubMessage(data: IUserClubMessages.DeleteParams): Promise<IUserClubMessages.Schema> {
    return http.post('user/delete-club-message', data || {})
  },

  doUpdateClubMessage(data: IUserClubMessages.UpdateParams): Promise<IUserClubMessages.Schema> {
    return http.post('user/update-club-message', data || {})
  },

  // ------- 메시지 카운트 풀링(추후 알람도 추가) -------
  getNotificationData(data: INotification.Params): Promise<INotification.Schema> {
    return http.get('user/getNotificationData', data || {})
  },

  // ------- 아이디 중복체크 인지 체크 -------
  doCheckDuplicateLogin(data: Schema$doCheckDuplicateLogin): Promise<object> {
    return http.post('user/do_check_duplicate_login', data)
  },

  getUserMissionList(data: IUserMission.Params): Promise<IUserMission.Schema> {
    return http.get('user/missionList', data || {})
  },

  pickUpMissionReward(data: IUserMissionReward.Params): Promise<IUserMissionReward.Schema> {
    return http.post('user/pickUpMissionReward', data || {})
  },

  pickUpAllMissionReward(): Promise<IUserMissionReward.Schema> {
    return http.post('user/pickUpAllMissionReward', {})
  },

  updateMissionCount(data: IUserMission.UpdateParams): Promise<Schema$UserMission> {
    return http.post('user/updateMissionCount', data || {})
  },

  setGuidePopupDisabled(): Promise<object> {
    return http.post('user/setGuidePopupDisabled', {})
  },

  usageGuideVideoWatched(): Promise<object> {
    return http.post('user/usageGuideVideoWatched', {})
  },

  getUsageGuideVideoAutoTarget(): Promise<IUsageGuideVideoAutoTarget.Schema> {
    return http.get('user/usageGuideVideoAutoTarget', {})
  },

  receiveGuideBonus(): Promise<Schema$UserGuideBonusResult> {
    return http.post('user/receiveGuideBonus', {})
  },

  getOwnedFreeLicense(): Promise<IUserItems.Schema> {
    return http.post('user/getOwnedFreeLicense', {})
  },

  updateChatOption(data: Partial<schema_user_chat_option>): Promise<Partial<schema_user_chat_option>> {
    return http.post('user/updateChatOption', data || {})
  },

  changeProfileImageByCustomPhoto(data: IChangeUserProfileImage.Params): Promise<IChangeUserProfileImage.Response> {
    return http.post('user/changeProfileImageByCustomPhoto', data || {})
  },

  resetProfileImageUrl(): Promise<IChangeUserProfileImage.Response> {
    return http.post('user/resetProfileImage', {})
  },

  updateChatBlockOrFavoriteUser(data: IUserChatBlockFavoriteOptions.Params) {
    return http.post('user/updateChatBlockOrFavoriteUser', data || {})
  },

  getUserAccounts(data: IUserAccounts.Params): Promise<IUserAccounts.Schema> {
    return http.post('user/getUserAccounts', data || {})
  },

  getNotReJoinableDroppedUser(data: IDroppedUser.Params): Promise<IDroppedUser.Schema> {
    return http.post('user/getNotReJoinableDroppedUser', data || {})
  },

  paymentRewardEvent(data: IPaymentRewardEvent.Params): Promise<IPaymentRewardEvent.Schema> {
    return http.post('user/paymentRewardEvent', data || {})
  },

  receivedPaymentRewardEvent(data: IReceivedPaymentRewardEvent.Params): Promise<IReceivedPaymentRewardEvent.Schema> {
    return http.post('user/receivedPaymentRewardEvent', data || {})
  },

  getNoticeByUser(): Promise<any> {
    return http.get('notice/noticeByUser', {})
  },

  createClubNoticeReadHistory(data: IClubNoticeReadHistory.Params): Promise<IClubNoticeReadHistory.Schema> {
    return http.post('user/createClubNoticeReadHistory', data || {})
  },

  registerPushwooshInfo(data) {
    return http.post('user/registerPushwooshInfo', data || {})
  },

  updateUserTitleEnabled(data: IUserTitleEnabled.Params): Promise<IUserTitleEnabled.Schema> {
    return http.post('user/updateUserTitleEnabled', data || {})
  },

  fetchUserTitleDefs(): Promise<IUserTitleDefs.Schema> {
    return http.get('user/userTitleDefs', {})
  },
  checkTransferableAccount(data: ICheckTransferableAccount.Params): Promise<ICheckTransferableAccount.Schema> {
    return http.post('user/checkTransferableAccount', data || {})
  },
  getTransferableAccountInfo(): Promise<ITransferableAccountInfo.Schema> {
    return http.get('user/getTransferableAccountInfo', {})
  },
  registerAccountTransfer(data: IRegisterAccountTransfer.Params): Promise<IRegisterAccountTransfer.Schema> {
    return http.post('user/registerAccountTransfer', data || {})
  },
  fetchFavoriteUsers(data: IFavoriteUsers.Params): Promise<IFavoriteUsers.Schema> {
    return http.get('user/fetchFavoriteUsers', data || {})
  },
  getFavoriteAlarmSetting(): Promise<IFavoriteAlarmSetting.Schema> {
    return http.get('user/favoriteAlarmSetting', {})
  },
  saveFavoriteAlarmSetting(data: FormData): Promise<IFavoriteAlarmSetting.Schema> {
    return http.post('user/favoriteAlarmSetting', data)
  },
  addFavoriteUsers(data: IFavoriteUsers.AddFavoriteUsersParams): Promise<IFavoriteUsers.AddFavoriteUserSchema> {
    return http.post('user/addFavoriteUsers', data || {})
  },
  removeFavoriteUsers(data: IFavoriteUsers.RemoveFavoriteUsersParams)
    : Promise<IFavoriteUsers.RemoveFavoriteUserSchema> {
    return http.post('user/removeFavoriteUsers', data || {})
  },
  addAllFavoriteUsers(data: IFavoriteUsers.AddAllFavoriteUsersParams): Promise<IFavoriteUsers.AddFavoriteUserSchema> {
    return http.post('user/addAllFavoriteUsers', data || {})
  },
  removeAllFavoriteUsers(data: IFavoriteUsers.RemoveAllFavoriteUsersParams)
    : Promise<IFavoriteUsers.RemoveFavoriteUserSchema> {
    return http.post('user/removeAllFavoriteUsers', data || {})
  },
}
